import { render, staticRenderFns } from "./NewPatient.vue?vue&type=template&id=d01cea90&scoped=true&"
import script from "./NewPatient.vue?vue&type=script&lang=js&"
export * from "./NewPatient.vue?vue&type=script&lang=js&"
import style0 from "./NewPatient.vue?vue&type=style&index=0&id=d01cea90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01cea90",
  null
  
)

export default component.exports